
            // Loaded lazily so the UI shell can initialize (and render the
            // greyed-out skeleton) while the data downloads
            window.data_promise = import("./data.json").then(function (m) {
                window.data = m.default;
            });
        